import { render } from "./app-logo-stripe.vue?vue&type=template&id=54f21f30"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-stripe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54f21f30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54f21f30', __exports__)) {
    console.log('reload')
    api.reload('54f21f30', __exports__)
  }
  
  module.hot.accept("./app-logo-stripe.vue?vue&type=template&id=54f21f30", () => {
    console.log('re-render')
    api.rerender('54f21f30', render)
  })

}


export default __exports__